<i class="icon icon-basket"
   aria-hidden="true"
   cy-basketBtn></i>